import React from 'react';

import MessageCampaignContentPreviewCard from 'components/message/MessageCampaignContentPreviewCard';
import { CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY } from 'config/PageAnchorConfig/CampaignAnchorConfig';
import DetailGeneralInfoCard from 'components/campaignStreamline/DetailGeneralInfoCard';


export const MESSAGE_CAMPAIGN_DETAIL_PAGE_CONFIG = {
  extraValidate: () => true,
  getDisplayComponentKeys: ({ detailData }) => {
    const displayLanguageSectionComponents = [
      'campaign_content_section_key',
      'campaign_detail_general_section_key',
    ];
    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents,
    };
  },
  normalSections: [],
  languageExtraTopSection: () => (
    <div id={CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.contentPage} />
  ),
  languageSections: [
    {
      sectionContent: [
        {
          key: 'campaign_content_section_key',
          complexComponent: ({ detailData, language }) => (
            <MessageCampaignContentPreviewCard
              language={language}
              campaignData={detailData}
              hideEditButton
            />
          ),
        },
      ],
    },
    {
      sectionKey: CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.detailGeneral,
      sectionContent: [
        {
          key: 'campaign_detail_general_section_key',
          complexComponent: ({ detailData, language }) => (
            <DetailGeneralInfoCard
              language={language}
              campaignData={detailData}
            />
          ),
        },
      ],
    },
  ],
};
